import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MenuItemModifier, MenuItemModifierCreate, MenuItemModifierFilter } from '../data/menuItemModifier';

export function createMenuItemModifierService(client: AxiosInstance) {
  return createCrudService<MenuItemModifier, MenuItemModifierCreate, MenuItemModifierFilter>(
    client,
    '/restaurant/MenuItemModifier',
    'id',
  );
}

export type MenuItemModifierService = CrudService<MenuItemModifier, MenuItemModifierCreate, MenuItemModifierFilter>;
